import React, { useState } from "react"
import queryString from "query-string"
import { FaSearch } from "react-icons/fa"
import { useRouter } from "next/router"
import clsx from "clsx"

import { SelectOption } from "@interfaces/ui"
import { Category } from "@interfaces/category"
import { RegularButton } from "@components/button"
import { Container, FlexBox } from "@components/wrapper"
import { ManualSelect } from "@components/input/manual"
import { Heading } from "@components/typography"

const timeOption: SelectOption[] = [
  {
    value: "",
    label: "Semua Waktu",
  },
  {
    value: "this_week",
    label: "Minggu Ini",
  },
  {
    value: "next_week",
    label: "Minggu Depan",
  },
  {
    value: "this_month",
    label: "Bulan Ini",
  },
  {
    value: "next_month",
    label: "Bulan Depan",
  },
]

export function RisebinarSearchPage({ categories }: { categories: Category[] }) {
  const [selectedTime, setSelectedTime] = useState("")
  const [selectedCategory, setSelectedCategory] = useState("")
  const [searchText, setSearchText] = useState("")

  const router = useRouter()

  const categoryOptions = () => {
    if (categories && categories.length) {
      const options = []

      options.push({
        value: "",
        label: "Semua Topik",
      })

      categories.map((value) => {
        options.push({
          value: value.category_slug,
          label: value.category_name,
        })
      })

      return options
    } else {
      return []
    }
  }

  const handleSelectTime = (e: any) => {
    setSelectedTime(e.value)
  }

  const handleSelectCategory = (e: any) => {
    setSelectedCategory(e.value)
  }

  const handleQuery = async () => {
    const obj = {
      page: 1,
      ...(selectedCategory && { category: selectedCategory }),
      ...(selectedTime && { time: selectedTime }),
      ...(searchText && { search: searchText }),
    }

    const stringify = queryString.stringify(obj)
    // window.location.assign(`?${stringify}`)
    await router.push(`?${stringify}#search-bar`)
  }

  function handleSearchInput(e: any) {
    setSearchText(e.target.value.replace(/[^\w\s]/gi, ""))
  }

  return (
    <Container id="search-bar">
      <div
        className={clsx(
          "w-full border-[1px] border-grey-97 rounded sm:p-6 flex sm:flex-row gap-5 sm:my-[60px]",
          "p-4 flex-col my-10"
        )}
      >
        <div className={clsx("sm:w-[38%]", "w-full")}>
          <Heading headingLevel="card-title" className={clsx("mb-3 sm:text-left", "text-center")}>
            Solusi apa yang kamu butuhkan
          </Heading>
          <FlexBox align="center" className="relative">
            <div className="absolute py-2 px-3 left-1">
              <FaSearch className="text-grey-97" />
            </div>
            <input
              id="search-field-risebinar"
              type="text"
              placeholder="Cari..."
              value={searchText}
              onChange={handleSearchInput}
              className={clsx(
                "w-full py-2.5 pl-10 pr-4 border-[1px] rounded-[4px] border-grey-97 focus:outline-none sm:text-base",
                "text-sm"
              )}
            />
          </FlexBox>
        </div>

        <div className={clsx("sm:w-[38%] gap-5 flex lg:flex-row ", "w-full flex-col gap-3")}>
          <FlexBox direction="col" className="w-full">
            <Heading headingLevel="card-title" className={clsx("mb-3 sm:flex", "hidden")}>
              Kategori
            </Heading>
            <ManualSelect
              inputId="dropdown-category-risebinar"
              instanceId={"category"}
              controlStyle={{
                border: "1px solid #979797",
              }}
              placeholder={"Semua Topik"}
              options={categoryOptions()}
              onChange={handleSelectCategory}
            />
          </FlexBox>

          <FlexBox direction="col" className="w-full">
            <Heading headingLevel="card-title" className={clsx("mb-3 sm:flex", "hidden")}>
              Waktu
            </Heading>
            <ManualSelect
              controlStyle={{
                border: "1px solid #979797",
              }}
              inputId="dropdown-time-risebinar"
              instanceId={"time"}
              placeholder={"Semua Waktu"}
              options={timeOption}
              onChange={handleSelectTime}
            />
          </FlexBox>
        </div>

        <FlexBox direction="col" className={clsx("sm:w-[24%]", "w-full")} justify="end">
          <RegularButton id="btn-search-risebinar" onClick={handleQuery} className="p-10">
            <div className="sm:py-[3px]">Cari</div>
          </RegularButton>
        </FlexBox>
      </div>
    </Container>
  )
}
